export default __webpack_public_path__ + "static/media/Mark-6-HUD-Radar.a735477a.jpg";